import React from "react";

function CobranzaConciliacionProductosCell({
  innerRef,
  style,
  productoParcialidad,
  cobranzaItem,
  abonarProducto,
}) {
  const {
    ordenId,
    nombreProducto,
    fechaVenta,
    precio,
    plazoQuincenal,
    abonoQuincenal,
    noAbono,
    totalAbonado,
    totalPendiente,
    pagoQuincena,
    nuevoSaldo,
    comision,
    //TODO checar si se removera?
    abonoAdicional,
  } = productoParcialidad || {};

  return (
    <tr className="table-light" ref={innerRef} style={{ ...style }}>
      <td
        style={{
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        <a
          href="#"
          onClick={(e) =>
            /*  openItem({
                                  ...productoParcialidad,
                                  itemCliente: "",
                                })*/
            {}
          }
        >
          {ordenId}
        </a>
      </td>
      <td>{nombreProducto}</td>
      <td style={{ textAlign: "center" }}>{fechaVenta}</td>
      <td style={{ textAlign: "center" }}>{precio}</td>
      <td style={{ textAlign: "center" }}>{plazoQuincenal}</td>
      <td style={{ textAlign: "center" }}>{abonoQuincenal}</td>
      <td style={{ textAlign: "center" }}>{noAbono}</td>
      <td style={{ textAlign: "center" }}>{totalAbonado}</td>
      <td style={{ textAlign: "center" }}>{totalPendiente}</td>
      <td style={{ textAlign: "center" }}>{pagoQuincena}</td>

      <td style={{ textAlign: "center" }}>{comision}</td>
      <td style={{ textAlign: "center" }}>{nuevoSaldo}</td>
      <td>
        <button
          type="button"
          className="btn btn-sm btn-warning"
          onClick={(event) => abonarProducto?.(event)}
          disabled={true}
          style={{ display: "none" }}
        >
          Abonar
        </button>
      </td>
    </tr>
  );
}

export default CobranzaConciliacionProductosCell;
